import { isOperand, Comparator, OperatorType } from './types.js';
const isNoAnswer = (answer) => {
    return (answer === undefined ||
        answer === null ||
        answer === '' ||
        (Array.isArray(answer) && answer.length === 0));
};
export const evaluateOperand = (operand, elementAnswers) => {
    const answer = elementAnswers.find((a) => a.field === operand.field)?.answer;
    if (isNoAnswer(answer)) {
        return false;
    }
    if (typeof answer === 'boolean') {
        throw new Error('Unsupported answer value type boolean');
    }
    const { match, comparator } = operand.matcher;
    const matches = Array.isArray(match) ? match : [match];
    const answers = Array.isArray(answer) ? answer : [answer];
    switch (comparator) {
        case Comparator.is:
            return evaluateIsMatch(matches, answers);
        case Comparator.isNot:
            return evaluateIsNotMatch(matches, answers);
        case Comparator.isExactly:
            return evaluateIsExactlyMatch(matches, answers);
        default:
            throw new Error(`Unsupported comparator: ${comparator}`);
    }
};
const evaluateIsMatch = (matchArray, answerArray) => {
    return matchArray.some((matchValue) => answerArray.includes(matchValue));
};
const evaluateIsNotMatch = (matchArray, answerArray) => {
    return !matchArray.some((matchValue) => answerArray.includes(matchValue));
};
const evaluateIsExactlyMatch = (matchArray, answerArray) => {
    const matchSet = new Set(matchArray);
    const answerSet = new Set(answerArray);
    return matchSet.size === answerSet.size && [...matchSet].every((item) => answerSet.has(item));
};
export const evaluateOperator = (operator, elementAnswers) => {
    if (operator.type === OperatorType.or) {
        return operator.conditions.some((condition) => {
            if (isOperand(condition)) {
                return evaluateOperand(condition, elementAnswers);
            }
            else {
                return evaluateOperator(condition, elementAnswers);
            }
        });
    }
    if (operator.type === OperatorType.and) {
        return operator.conditions.every((condition) => {
            if (isOperand(condition)) {
                return evaluateOperand(condition, elementAnswers);
            }
            else {
                return evaluateOperator(condition, elementAnswers);
            }
        });
    }
    throw new Error(`Unsupported operator type: ${operator.type}`);
};
